import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Checkbox } from '@node-space/ui-components'
import { AgreementLink } from '../helpers/types'

interface DakotaTermsProps {
  agreements: AgreementLink[]
  isSubmittingAgreements: boolean
  onSubmitAgreements: () => void
}

export const DakotaTerms = ({
  agreements,
  isSubmittingAgreements,
  onSubmitAgreements,
}: DakotaTermsProps) => {
  const { t } = useTranslation()
  const [checkedAgreements, setCheckedAgreements] = useState<string[]>([])

  const onClickAgreementCheckbox = (id: string) => {
    setCheckedAgreements(current =>
      current?.includes(id) ? current?.filter(currentId => currentId !== id) : [...current, id]
    )
  }

  return (
    <>
      <p className="text-body-regular">
        {t('customerPendingAgreements.variations.dakota.byClickingSubmit')}
        <span className="text-body-strong">
          {t('customerPendingAgreements.variations.dakota.bvnkMalta')}
        </span>
        {t('customerPendingAgreements.variations.dakota.systemPayServicesSpain')}
        <span className="text-body-strong">
          {t('customerPendingAgreements.variations.dakota.bvnkSpain')}
        </span>
        {t('customerPendingAgreements.variations.dakota.collectively')}
        <span className="text-body-strong">“BVNK”</span>
        {t('customerPendingAgreements.variations.dakota.confirm')}
      </p>
      <Box flexCol gapY={16}>
        {agreements?.map(({ id, label, url }) => (
          <Checkbox
            key={id}
            id={`${id}Checkbox`}
            testId={`${id}Checkbox`}
            name={`${id}Checkbox`}
            label="{{agreementLink}}"
            labelLinks={{ agreementLink: { text: label, href: url, target: '_blank' } }}
            checked={checkedAgreements?.includes(id)}
            onCheckedChange={() => onClickAgreementCheckbox(id)}
          />
        ))}
      </Box>
      <Box flex justify="center">
        <Button
          loading={isSubmittingAgreements}
          onClick={onSubmitAgreements}
          disabled={checkedAgreements?.length !== agreements?.length}
          full
          className="sm:max-w-[318px]"
        >
          {t('submit')}
        </Button>
      </Box>
    </>
  )
}
